import React from "react";
import CareerListingPresenter from "./CareerListing.presenter";
import { bindActionCreators, Dispatch } from "redux";
import { connect } from "react-redux";
import { MapStateToProps, MapDispatchToProps, C_Props, MergedProps, C_States } from "./CareerListing.type";
import { RootState, TCb, AppNotifications, LanguageOutputModel, CareerOutputModel } from "../../../models";
import { NotificationActions, AllLanguageListActions } from "../../../store/actions";
import { APP_ROUTES, INITIAL_FETCHING_PAGINATION_DATA } from "../../../constants";
import { CareerService } from "../../../services";
import { CareerUtil, loadCallback } from "../../../utils";
import { withRouter } from "react-router-dom";
import _ from "lodash";

const EMPTY_FILTER: C_States["filter"] = {
  searchValue: "",
};
class CareerListingContainer extends React.Component<MergedProps, C_States> {
  constructor(props) {
    super(props);

    const careerId = this.props.match.params.careerCode;
    this.state = {
      fetchedCareer: INITIAL_FETCHING_PAGINATION_DATA,
      visibleCareerId: careerId,
      visibleCareerForm: Boolean(careerId),
      filter: EMPTY_FILTER,
      statusFilter: {
        publish: true,
        unpublish: true,
      },
      statusQuery: [],
    };
  }

  openCareerForm = (careerCode?: string) => {
    this.setState({ visibleCareerId: careerCode, visibleCareerForm: true }, () => {
      if (careerCode) {
        this.props.history.push(CareerUtil.buildCareerDetail(careerCode));
      }
    });
  };

  closeCareerForm = (cb?: TCb) => {
    this.props.history.push(APP_ROUTES.PAGEMANAGEMENT.CAREER.BASE);
    this.setState({ visibleCareerId: undefined, visibleCareerForm: false }, () => {
      loadCallback(cb?.success);
    });
  };

  onApplyFilter = (loadMore: boolean, cb?: TCb) => {
    if (this.state.fetchedCareer.loading && loadMore) return;

    this.setState(
      (prevState) => {
        return {
          fetchedCareer: {
            ...prevState.fetchedCareer,
            data: loadMore ? prevState.fetchedCareer.data : [],
            loading: true,
          },
        };
      },
      () => {
        const query: Parameters<typeof CareerService.filterCareers>[0] = {
          page: this.state.fetchedCareer.page,
          limit: this.state.fetchedCareer.limit,
          languageId: this.props.all_language_list.data.find((e: LanguageOutputModel) => e.isPrimary)?.id,
          searchValue: this.state.filter.searchValue || undefined,
          status: this.state.statusQuery || undefined,
        };

        CareerService.filterCareers(query)
          .then((res) => {
            if (res && res.data?.data) {
              this.setState(
                (prevState) => {
                  let careers: CareerOutputModel[] = [...res.data.data];

                  if (loadMore) {
                    careers.unshift(...prevState.fetchedCareer.data);
                  }

                  return {
                    fetchedCareer: {
                      ...res.data,
                      data: careers,
                      loading: false,
                    },
                  };
                },
                () => {
                  loadCallback(cb?.success);
                }
              );
            } else {
              this.props.actions.enqueueSnackbar({
                type: AppNotifications.ERROR,
                message: "Load data failed",
              });
              this.setState({
                fetchedCareer: INITIAL_FETCHING_PAGINATION_DATA,
              });
            }
          })
          .catch((err) => {
            this.props.actions.enqueueSnackbar({
              type: AppNotifications.ERROR,
              message: "Load data failed",
            });
            this.setState({
              fetchedCareer: INITIAL_FETCHING_PAGINATION_DATA,
            });
          });
      }
    );
  };

  onLoadMore = () => {
    this.onApplyFilter(true);
  };

  onDeleteCareer = (code: string | null) => {
    code &&
      CareerService.deleteCareer(code!)
        .then((res) => {
          if (res && (res.status === 200 || res.status === 201)) {
            this.props.actions.enqueueSnackbar({
              type: AppNotifications.SUCCESS,
              message: "Delete career success",
            });
            this.onApplyFilter(false);
          } else {
            this.props.actions.enqueueSnackbar({
              type: AppNotifications.ERROR,
              message: "Delete career failed",
            });
          }
        })
        .catch((err) => {
          this.props.actions.enqueueSnackbar({
            type: AppNotifications.ERROR,
            message: "Delete career failed",
          });
        });
  };

  handleChangeCheckBox = (event) => {
    this.setState(
      {
        statusFilter: {
          ...this.state.statusFilter,
          [event.target.name]: event.target.checked,
        },
      },
      () => {
        let statusQuery: string[] = [];
        for (const key in this.state.statusFilter) {
          if (this.state.statusFilter[key] === true) {
            statusQuery.push(key);
          }
        }
        this.setState({ statusQuery });
      }
    );
  };

  clearFilter = () => {
    this.setState({
      statusFilter: {
        publish: false,
        unpublish: false,
      },
    });
  };

  onApplyStatusFilter = () => {
    this.onApplyFilter(false);
  };

  onSearch = _.debounce((searchValue: string) => {
    this.setState(
      (prevState) => {
        return {
          filter: {
            ...prevState.filter,
            searchValue,
          },
        };
      },
      () => {
        this.onApplyFilter(false);
      }
    );
  }, 300);

  render() {
    return (
      <CareerListingPresenter
        {...this.props}
        {...this.state}
        handleChangeCheckBox={this.handleChangeCheckBox}
        clearFilter={this.clearFilter}
        onSearch={this.onSearch}
        onApplyStatusFilter={this.onApplyStatusFilter}
        onLoadMore={this.onLoadMore}
        openCareerForm={this.openCareerForm}
        closeCareerForm={this.closeCareerForm}
        onRefreshCareerList={() => this.onApplyFilter(false)}
        onDeleteCareer={this.onDeleteCareer}
      />
    );
  }

  componentDidMount() {
    const filterFunc = () => {
      this.onApplyFilter(true, {
        success: () => {},
      });
    };
    if (!this.props.all_language_list.data.length) {
      this.props.actions.getAllLanguages({
        success: () => {
          filterFunc();
        },
      });
    } else {
      filterFunc();
    }
  }
}

export default withRouter<C_Props, any>(
  connect<MapStateToProps, MapDispatchToProps, C_Props, RootState>(
    (state: RootState) => ({
      all_language_list: state.all_language_list,
    }),
    (dispatch: Dispatch) => ({
      actions: bindActionCreators(Object.assign(NotificationActions, AllLanguageListActions), dispatch),
    })
  )(CareerListingContainer)
);
